import { SET_PARTNER_TAGS, CLEAR_PARTNER_TAGS, CLEAR_SEARCH } from '../actions/types';

const partnerTags = (state = null, action) => {
  switch (action.type) {
    case SET_PARTNER_TAGS:
      return action.partnerTagsArray;
    case CLEAR_SEARCH:
    case CLEAR_PARTNER_TAGS:
      return null;
    default:
      return state;
  }
};

export default partnerTags;
